import React from 'react';

export const FormColumn = ({ children, className = '' }) => {
	return <div className={`form-column ${className}`}>{children}</div>;
};
